import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthenticationService } from 'app/core/authentication.service';
import { UserService } from 'app/core/user.service';
import { UpdatePassword } from 'app/models/request/updatePassword';
import { Login } from 'app/shared/models/login';
import { NotificationsService } from 'app/utils/notifications.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-update-password',
  templateUrl: './update-password.component.html',
  styleUrls: ['./update-password.component.css']
})
export class UpdatePasswordComponent implements OnInit {
  login: UpdatePassword;
  form: FormGroup;
  error: string = '';

  constructor(private router: Router,
              private authSrv: AuthenticationService,
              private userService: UserService,
              private notification: NotificationsService,
              public activeModal: NgbActiveModal,
              private fb: FormBuilder) { }

  ngOnInit() {
    this.form = this.fb.group({
      ancien: ['', [Validators.required,Validators.minLength(4), Validators.maxLength(10)]],
      nouveau: ['', [Validators.required,Validators.minLength(4), Validators.maxLength(10)]],
      confirmation: ['', [Validators.required,Validators.minLength(4), Validators.maxLength(10)]]
    });
  }

  submit() {
    this.login = this.form.value;
    console.log(this.login);

    this.userService.updatePassword(this.login)
    .subscribe((login) => {
      this.notification.addToast("Mot de passe Modifier", "infos", "success");
          this.authSrv.logout();
          this.router.navigate(['login']);

    this.activeModal.dismiss();
    },(erreur)=>{
      this.notification.addToast("Erreur Sur Modification", "Erreur", "error");
      console.log(erreur);
      this.error = 'Verifier les Informations';

    });
  }
}



// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/authentication/update-password/update-password.component.ts